import Reflux from 'reflux';

const LdapActions = Reflux.createActions({
  loadSettings: { asyncResult: true },
  update: { asyncResult: true },
  testServerConnection: { asyncResult: true },
  testLogin: { asyncResult: true },
});

export default LdapActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/ldap/LdapActions.js